const initialBoard = {
  toggleButton: false,
}

const headerReducer = (state = initialBoard, action) => {
  switch (action.type) {
    case 'CHANGE_SIDEBAR_ACTION':
      return {
        ...state,
        toggleButton: action.payload,
      }
    default:
      return { ...state }
  }
}

export default headerReducer
